// replace initial object with key-value pairs or array of strings
// with array of objects where:
// 'label' equals initial object prop name / array item value,
// 'value' equals object key value / array item value
import isPlainObject from 'lodash/isPlainObject';
import isArray from 'lodash/isArray';
import keys from 'lodash/keys';

const processConstants = constantsSets => {
  return keys(constantsSets).reduce((acc, key) => {
    const currentConst = constantsSets[key];

    if (isPlainObject(currentConst) || isArray(currentConst)) {
      const iterableConsts = isPlainObject(currentConst)
        ? Object.keys(currentConst)
        : currentConst;
      // eslint-disable-next-line no-param-reassign
      acc[key] = iterableConsts.reduce((prev, cur) => {
        prev.push({
          label: isPlainObject(cur) ? cur.name : cur,
          value: isPlainObject(currentConst) ? currentConst[cur] : cur,
        });
        return prev;
      }, []);
    } else {
      acc[key] = currentConst;
    }

    return acc;
  }, {});
};

export default processConstants;



// WEBPACK FOOTER //
// ./src/redux/data/process-constants.js